import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import { connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import THEME from 'app/styles/theme';
import TopBar from 'app/components/TopBar';
import SearchForm from './SearchForm';
import SearchProgress from './SearchProgress';
import SearchResults from './SearchResults';
import Footer from 'app/components/Footer';
import Loading from 'app/ui_components/Loading';

import { loadReport, checkIfStaff, handleSearchParam, getUsfoodCustomerData } from 'app/redux/actions';

import animate from 'app/helpers/animations/app';
import { EMPLOYEE } from 'app/helpers/constants';

import { isProduction } from 'app/helpers/utils';

class App extends React.Component {
  static propTypes = {
    step: PropTypes.number.isRequired,
    handleReportAccessAttempt: PropTypes.func.isRequired,
    loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired,
    handleSearchParam: PropTypes.func.isRequired,
    handleUsfoodCustomerData: PropTypes.func,
    usFoods: PropTypes.bool,
    userType: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.layout = {
      width: [1 / 1],
      mx: 'auto',
      px: [20, 0],
    };
    this.animate = animate;
  }

  startGoogleAnalytics = (isStaff = false, usFoods = false) => {
    ReactGA.initialize(process.env.GOOGLE_ANALYTICS_UA);
    ReactGA.set({
      dimension1: isStaff.toString(),
      dimension2: usFoods.toString(),
    });
  };

  checkIfAttemptingToAccessReport = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('report')) {
      const reportId = params.get('report');
      this.props.handleReportAccessAttempt(reportId);
    } else {
      ReactGA.pageview('Landing Page');
      window.fbq && window.fbq('track', 'PageView');
    }
  };

  checkForUTMs = () => {
    const params = new URLSearchParams(window.location.search);
    const utms = ['utm_source', 'utm_content', 'lead_source'];
    for (var i = 0; i < utms.length; i++) {
      const key = utms[i];
      if (params.has(key)) {
        this.props.handleSearchParam(key, params.get(key));
      }
    }
  };

  checkForUSFs = () => {
    const { usFoods, handleUsfoodCustomerData } = this.props;
    const params = new URLSearchParams(window.location.search);

    if (!usFoods) {
      return;
    }

    const payload = params.get('payload');
    const iv = params.get('iv');

    if (payload && iv) {
      handleUsfoodCustomerData(
        {'payload': payload,
          'iv': iv
        });
    }
  };

  async componentDidMount() {
    const { usFoods, checkIfStaff } = this.props;
    const isStaff = await checkIfStaff();
    this.startGoogleAnalytics(isStaff, usFoods);
    this.checkIfAttemptingToAccessReport();
    this.checkForUTMs();
    this.checkForUSFs();
    this.animate();
  }

  render() {
    const {
      layout,
      props: { step, loading, userType, usFoods }
    } = this;

    const numSteps = (usFoods && userType && userType !== EMPLOYEE) ? 2 : 3;
    // Has numSteps = 2 when is usFood and the userType !=== EMPLOYEE
    // when a user is usFood and is employee and when is not usFood has numSteps = 3
    return (
      <ThemeProvider theme={THEME}>
        <React.Fragment>
          <TopBar numSteps={numSteps} step={step} />
          {loading !== 'report' ? (
            <React.Fragment>
              {step === 0 && <SearchForm layout={layout} />}
              {step === 1 && <SearchProgress />}
              {numSteps === 2 ? (
                <React.Fragment>
                  {step === 2 && <SearchProgress />}
                  {step === 3 && <SearchResults layout={layout} />}
                </React.Fragment>
              ) : (step >= 2 && <SearchResults layout={layout} />)}
              {step < 2 && <Footer />}
            </React.Fragment>
          ) : (
            <Loading />
          )}
        </React.Fragment>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (
  { step,
    loading,
    usFoods,
    user: { userType }
  }) => ({
  step,
  loading,
  usFoods,
  userType
});

const mapDispatchToProps = dispatch => ({
  handleReportAccessAttempt: slug => dispatch(loadReport(slug)),
  checkIfStaff: () => dispatch(checkIfStaff()),
  handleSearchParam: (param, value) =>
    dispatch(handleSearchParam(param, value)),
  handleUsfoodCustomerData: ({payload, iv}) =>
    dispatch(getUsfoodCustomerData(payload, iv))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);
